module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.RaftFoundation.UnpiledRaft2m.685fba71.png";